import React from "react";
import { INTERACTIVE_CLASSES } from "../../interactive-product-classes.js";
import {
	getButtonContentFromImages,
	getButtonModifierClasses,
} from "./utils/button-utils.jsx";
import { getOpenInNewProps } from "../../links/open-in-new.js";

export const INTERACTIVE_BUTTON_TYPE = Object.freeze({
	SMALL_ROUND: "small-round",
	NORMAL_ROUND: "normal-round",
})

export const InteractiveButton = ({
	maskImageSrc,
	buttonImageSrc,
	colorful = false,
	colorfulActive = false,
	onClick = undefined,
	disabled = false,

	innerContent = undefined,

	buttonType = INTERACTIVE_BUTTON_TYPE.SMALL_ROUND,

	additionalButtonWrapperClass = "",

	imgIconImageAlt = undefined,

	title = undefined,

	href = undefined,

	linkOpenInNewTab = false,
}) => {
	const { activeClass, disabledClass, usedColorClass } =
		getButtonModifierClasses({
			colorful,
			colorfulActive,
			disabled,
		});

	const typesToClassesWrapper = {
		[INTERACTIVE_BUTTON_TYPE.SMALL_ROUND]: INTERACTIVE_CLASSES.BUTTON_WRAPPER_SMALL_ROUND,
		[INTERACTIVE_BUTTON_TYPE.NORMAL_ROUND]: INTERACTIVE_CLASSES.BUTTON_WRAPPER_NORMAL_ROUND,
	};

	const fullClass = `${INTERACTIVE_CLASSES.BUTTON_WRAPPER_ICON} ${usedColorClass} ${activeClass}`;

	const content = getButtonContentFromImages({
		maskImageSrc,
		buttonImageSrc,
		contentClass: fullClass,
		imgAlt: imgIconImageAlt,
	});

	const handleButtonClick = (event) => {
		if (onClick) {
			onClick(event);
		}
	};

	const completeContent = (
		<>
			{content}
			{innerContent}
		</>
	);

	const commonProps = {
		className: `${INTERACTIVE_CLASSES.BUTTON_WRAPPER} ${disabledClass} ${typesToClassesWrapper[buttonType]} ${additionalButtonWrapperClass}`,
		onClick: handleButtonClick,
		title,
	};

	const openInNewProps = getOpenInNewProps(linkOpenInNewTab);

	if (href) {
		return (
			<a {...commonProps} {...openInNewProps} href={href}>
				{completeContent}
			</a>
		);
	}

	return (
		<button {...commonProps} disabled={disabled}>
			{completeContent}
		</button>
	);
};
